<template>
  <MenuPanelTop>
    <div
      class="gorizontal-menu flex-center bg-white relative justify-between !h-full md:!pl-10 md:!pr-[30px] max-md:!px-4 max-md:!h-auto max-md:!py-2"
    >
      <button
        class="max-md:flex md:hidden"
        @click="isOpenMenu = !isOpenMenu"
        v-if="route.name !== 'index' && userModule.id"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <rect x="4" y="8" width="20" height="1.5" rx="0.75" fill="#3A3D44" fill-opacity="0.6" />
          <rect x="4" y="18" width="20" height="1.5" rx="0.75" fill="#3A3D44" fill-opacity="0.6" />
        </svg>
      </button>

      <NuxtLink to="/" class="flex items-center gap-3 max-md:gap-1.5 max-md:ml-3 w-fit">
        <img src="@/public/assets/img/logo.svg" alt="logo" class="w-10 max-md:w-6" />
        <UINewIconsILogoName
          class="max-md:h-5 text-txmain mt-0.5 w-auto"
        />
      </NuxtLink>

      <div
        v-if="route.name === 'index'"
        class="absolute top-0 left-1/2 -translate-x-1/2 h-full z-10 max-md:hidden"
      >
        <div class="flex items-center justify-center h-full">
          <div
            class="text-2xl font-bold p-1 border border-[#3176FF14] rounded-2xl flex items-center gap-1 cursor-pointer"
          >
            <div
              class="h-[34px] bg-[#F3F3FF] w-[196px] flex items-center justify-center rounded-xl"
            >
              <div class="text-xs text-primary">Рекламодателям</div>
            </div>
            <NuxtLink
              to="https://publisher.telepost.pro/"
              class="h-[34px] w-[196px] flex items-center justify-center rounded-xl hover:bg-[#F3F3FF] group transition-all cursor-pointer"
            >
              <div class="text-xs text-[#3A3D44] group-hover:text-primary transition-all">
                Владельцам каналов
              </div>
            </NuxtLink>
          </div>
        </div>
      </div>

      <div class="flex items-center h-full max-md:gap-1">
        <MainBusket />

        <div class="flex items-center h-full">
          <template v-if="userModule.id">
            <NuxtLink
              v-if="walletStore.hasWallet"
              to="/balance"
              class="h-full px-4 max-md:hidden flex items-center gap-2 text-txmain hover:opacity-80 transition-opacity"
            >
              <ICardBalance class="opacity-60" />
              <span class="text-sm font-bold whitespace-nowrap">
                {{ formattedBalance }}
              </span>
            </NuxtLink>
            <NuxtLink
              to="/notifications"
              class="h-full px-6 max-md:px-2 flex items-center justify-center"
            >
              <IBell class="opacity-45" />
            </NuxtLink>
            <div
              class="h-full pl-6 max-md:pl-2 pr-[10px] max-md:pr-0 flex items-center justify-center"
            >
              <div
                ref="target"
                class="flex items-center gap-2 cursor-pointer relative"
                @click="isOpenDropdown = !isOpenDropdown"
              >
                <div
                  class="min-w-10 min-h-10 size-10 max-md:size-8 max-md:min-w-8 max-md:min-h-8 rounded-full bg-gray-100 mr-2 max-md:mr-0 overflow-hidden"
                >
                  <img
                    v-if="user && user.avatar"
                    :src="user.avatar"
                    alt="avatar"
                    class="w-full h-full object-cover rounded-full"
                  />
                </div>
                <div
                  class="text-txmain text-nowrap max-md:hidden"
                  :class="$route.name === 'ch-id' ? '!text-white' : ''"
                >
                  {{ (user && (user.name || user.telegram || user.email)) || "Имя не указано" }}
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="#3A3D44"
                  class="max-md:hidden"
                  :class="$route.name === 'ch-id' ? '!text-white' : ''"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.0012 13.3329C9.81123 13.3329 9.62206 13.2687 9.46789 13.1396L4.46789 8.97291C4.11456 8.67875 4.06623 8.15291 4.36123 7.79958C4.65539 7.44625 5.18039 7.39875 5.53456 7.69291L10.0104 11.4229L14.4787 7.82708C14.8371 7.53875 15.3621 7.59541 15.6504 7.95375C15.9387 8.31208 15.8821 8.83625 15.5237 9.12541L10.5237 13.1487C10.3712 13.2712 10.1862 13.3329 10.0012 13.3329Z"
                    fill="currentColor"
                  />
                </svg>
                <div
                  v-if="isOpenDropdown"
                  class="absolute top-12 right-0 w-[200px] py-2 bg-white border rounded-xl z-50"
                >
                  <NuxtLink
                    to="/settings"
                    class="flex items-center gap-1 cursor-pointer px-4 py-2 hover:bg-gray-100 text-[#3A3D44] font-normal w-full"
                    >Настройки</NuxtLink
                  >
                  <NuxtLink
                    to="/publisher"
                    target="_blank"
                    class="flex items-center gap-1 cursor-pointer px-4 py-2 hover:bg-gray-100 text-[#3A3D44] font-normal w-full"
                    >Кабинет паблишера</NuxtLink
                  >
                  <div
                    class="flex items-center gap-1 cursor-pointer px-4 py-2 hover:bg-gray-100 text-[#3A3D44] w-full"
                    @click="logout"
                  >
                    Выход
                  </div>
                </div>
              </div>
            </div>
          </template>
          <UINewButton
            v-else
            class="h-[50px] !px-6 !py-2 !rounded-xl max-md:!h-auto max-md:!py-1.5 max-md:!px-4 max-md:!text-sm"
            variant="light"
            @click="userModule.loginDialogVisible = true"
            >Войти</UINewButton
          >
        </div>
      </div>
    </div>
  </MenuPanelTop>
</template>

<script setup lang="ts">
  import IBell from "~/components/UINew/icons/IBell.vue";
  import ICardBalance from "~/components/UINew/icons/ICardBalance.vue";
  import AuthService from "@/services/AuthService";
  import { useUserStore } from "~/store/UserModule";
  import { useWalletStore } from "~/store/WalletModule";
  import { useBasketStore } from "~/store/BasketModule";
  import { clearOrderLocalStorage } from "~/common/orderLocalData";
  import { isPublicRoute } from "~/common/publicRoutes";
  import { onClickOutside } from "@vueuse/core";
  import { jwtDecode } from "jwt-decode";

  const userModule = useUserStore();
  const { name, user, isOpenMenu } = storeToRefs(userModule);
  const walletStore = useWalletStore();
  const { balance } = storeToRefs(walletStore);
  const basketStore = useBasketStore();

  const formattedBalance = computed(() => `${balance.value.toLocaleString("ru-RU")} ₽`);

  const isOpenDropdown = ref<boolean>(false);
  const target = ref(null);
  const route = useRoute();
  const router = useRouter();

  /**
   * Публичная ли страница сейчас.
   *
   * Маршрут спрашиваем у роутера, а не через route из setup: при переходе из
   * кабинета паблишера layout меняется, шапка монтируется заново, и на момент
   * mounted в route ещё лежит предыдущий адрес. Из-за этого блог считался
   * закрытой страницей и посетителя уводило на главную.
   */
  const isPublicPage = () => isPublicRoute(String(router.currentRoute.value.name || ""));

  // SSR-safe: onClickOutside uses DOM under the hood
  if (import.meta.client) {
    onClickOutside(target, () => {
      isOpenDropdown.value = false;
    });
  }

  const clearOrderLocalData = () => {
    clearOrderLocalStorage();
    // Сбрасываем in-memory состояние корзины (Pinia-стор живёт между навигациями)
    basketStore.basket = [];
    basketStore.campaignName = "";
    basketStore.setDraftStatus(false);
    basketStore.setDraftId(0);
  };

  const logout = () => {
    userModule.resetAuthKey();
    clearOrderLocalData();
    useCookie("accessTokenSJ").value = null;
    useCookie("authorizedP").value = null;
    if (!isPublicPage()) {
      navigateTo("/");
    }
  };

  /**
   * Шапка проверяет сессию рекламодателя, но публичные страницы — блог,
   * каталог, лендинг, карточки каналов — открыты всем. Посетитель может прийти
   * из поиска или из кабинета паблишера, где токена рекламодателя нет или он
   * давно протух; уводить его оттуда нельзя. Поэтому на таких страницах шапка
   * только подхватывает данные пользователя, если они доступны, и ничего
   * не решает за него.
   */
  onMounted(async () => {
    const isPublic = isPublicPage();
    const token = localStorage.getItem("useUserStore__authorized");

    if (!token) {
      if (!isPublic) {
        logout();
        navigateTo("/");
      }
      return;
    }

    // Токен может оказаться не JWT — например, чужим или обрезанным,
    // тогда считаем его негодным, а не роняем весь обработчик
    let isExpired = true;
    try {
      const decoded = jwtDecode<{ exp?: number }>(token);
      isExpired = typeof decoded.exp === "number" && decoded.exp < Date.now() / 1000;
    } catch {
      isExpired = true;
    }

    if (isExpired) {
      localStorage.removeItem("useUserStore__authorized");
      clearOrderLocalData();
      if (!isPublic) navigateTo("/");
      return;
    }

    try {
      const data = await AuthService.getUser();
      name.value = data.telegram;
      user.value = data;
      if (data.telegramId) {
        userModule.telegramId = data.telegramId;
      }
      walletStore.fetchWallet();
    } catch (error) {
      // Профиль не отдался: на публичной странице это не мешает читать её
      // дальше, шапка просто останется без имени и баланса
      if (!isPublic) throw error;
    }
  });
</script>

<style scoped></style>
